<template>
    <div class="audio-editor-scale" :style="`width: ${width}px`">
        <div
            v-for="second in fullSeconds"
            :key="second"
            class="audio-editor-scale__mark"
            :style="styles"
        >
            <div class="audio-editor-scale__sec" v-text="`${second}s`" />
            <div class="audio-editor-scale__ms">
                <span v-for="i in 10" :key="i" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AudioEditorScale',
    props: {
        duration: {
            type: Number,
            required: true
        },
        precision: {
            type: Number,
            required: true
        },
        width: {
            type: Number,
            required: true
        }
    },

    computed: {
        styles() {
            return {
                width: `${Math.ceil(1000 / this.precision)}px`
            };
        },
        fullSeconds() {
            return Math.floor(this.duration / 1000);
        }
    }
};
</script>

<style lang="scss" src="./AudioEditorScale.scss"></style>
